module.exports = __webpack_public_path__ + "235c13d01052442dc780247032a41df6.svg";